import type { GridConfig, HiddenRegion, Point } from './types';

export const createGridToPixel =
  (grid: GridConfig, width: number, height: number) =>
  (point: Point): Point => ({
    x:
      grid.paddingX + point.x * ((width - 2 * grid.paddingX) / (grid.cols - 1)),
    y:
      grid.paddingY +
      point.y * ((height - 2 * grid.paddingY) / (grid.rows - 1)),
  });

export const createIsDotHidden =
  (hiddenRegions: HiddenRegion[]) =>
  (col: number, row: number): boolean => {
    return hiddenRegions.some(
      (region) =>
        col >= region.minX &&
        col <= region.maxX &&
        row >= region.minY &&
        row <= region.maxY,
    );
  };
